import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
let AfterSales = class AfterSales extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.saving = false;
        this.formValid = true;
        this.list = [];
        this.total = 0;
        this.editFormPanels = [0, 1, 2, 3, 4, 5]; // 默认展开所有面板
        // 搜索选项
        this.searchOptions = {
            quickly: '',
            hospital: null,
            deviceMode: '',
            status: null
        };
        // 分页选项
        this.options = {
            page: 1,
            itemsPerPage: 20,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: [],
            multiSort: false,
            mustSort: false
        };
        // 对话框
        this.dialog = {
            visible: false,
            title: '编辑设备信息'
        };
        // 表单数据
        this.formData = {};
        this.selectedItem = {};
        // 故障历史相关
        this.showMalfunctionHistory = false;
        this.loadingMalfunctions = false;
        this.malfunctionHistory = [];
        this.malfunctionCurrentPage = 1;
        this.malfunctionPageSize = 10;
        this.malfunctionHeaders = [
            { text: '故障类别', value: 'category', width: '120px', sortable: false },
            { text: '故障时间', value: 'date', width: '140px', sortable: true },
            { text: '故障模块', value: 'module', width: '120px', sortable: false },
            { text: '故障描述', value: 'description', sortable: false },
            { text: '负责人', value: 'responsible', width: '100px', sortable: false },
            { text: '状态', value: 'status', width: '80px', sortable: false }
        ];
        // 导出表单
        this.exportForm = {
            menuVisible: false
        };
        // 医院列表
        this.listHospital = [];
        // HIS信息展开状态
        this.hisInfoExpanded = false;
        // 状态列表 - 基于后端返回的 isEnabled 字段
        this.statusList = [
            { text: '全部', value: null },
            { text: '启用', value: true },
            { text: '停用', value: false }
        ];
        // 表格头部
        this.headers = [
            // 设备使用信息组
            { text: '设备型号', value: 'deviceMode', sortable: true, group: 'deviceInfo' },
            { text: '设备编号', value: 'deviceNo', sortable: true, group: 'deviceInfo' },
            { text: '医院名称', value: 'hospitalName', sortable: true, group: 'deviceInfo', width: 120 },
            // { text: '使用科室', value: 'department', sortable: false, group: 'deviceInfo' },
            { text: '售后', value: 'afterSalesStaff', sortable: false, group: 'deviceInfo' },
            // 授权信息组
            { text: '授权信息', value: 'authInfo', sortable: false, group: 'authInfo' },
            // 维护保养组
            { text: '是否启用', value: 'isEnabled', sortable: true, group: 'maintainInfo' },
            { text: '上次维护日期', value: 'lastMaintainDate', sortable: true, group: 'maintainInfo' },
            { text: '预计维护日期', value: 'nextMaintainDate', sortable: true, group: 'maintainInfo' },
            { text: '日业务量', value: 'dailyVolume', sortable: true, group: 'maintainInfo' },
            // 汇总使用数据组
            { text: '调配支数', value: 'dispensingCount', sortable: true, group: 'usageData' },
            { text: '调配付数/洗消数', value: 'dispensingBags', sortable: true, group: 'usageData' },
            { text: '故障次数', value: 'failureCount', sortable: true, group: 'usageData' },
            { text: '成功率', value: 'successRate', sortable: true, group: 'usageData', width: 75 },
            { text: '无故障时长', value: 'faultFreeTime', sortable: false, group: 'usageData' },
            { text: 'HIS', value: 'hisInfo', sortable: false, group: 'hospitalData' },
            // 操作列
            { text: '操作', value: 'actions', sortable: false, width: 150 }
        ];
    }
    // 设备类型列表 - 使用全局存储
    get deviceModeList() {
        return this.deviceTypeList || [];
    }
    get dynamicHeight() {
        return `${window.innerHeight - 64}px`;
    }
    // 故障历史分页相关计算属性
    get malfunctionTotalPages() {
        return Math.ceil(this.malfunctionHistory.length / this.malfunctionPageSize);
    }
    get paginatedMalfunctions() {
        const start = (this.malfunctionCurrentPage - 1) * this.malfunctionPageSize;
        const end = start + this.malfunctionPageSize;
        return this.malfunctionHistory.slice(start, end);
    }
    async mounted() {
        // 获取设备类型列表
        await this.fetchDeviceModeCatalog();
        this.getHospitalList();
        this.getList();
    }
    // 监听分页变化
    onOptionsChanged() {
        this.getList();
    }
    // 监听搜索条件变化
    onSearchOptionsChanged() {
        // 重置到第一页
        this.options.page = 1;
        this.getList();
    }
    // 获取医院列表
    async getHospitalList() {
        try {
            const response = await this.axios.get('/api/hospital');
            this.listHospital = response.data.result || [];
        }
        catch (error) {
            console.error('获取医院列表失败:', error);
        }
    }
    // 获取数据列表
    async getList() {
        this.loading = true;
        try {
            const params = {
                page: this.options.page,
                limit: this.options.itemsPerPage,
                ...this.searchOptions
            };
            const response = await this.axios.get('/api/device/after-sales', { params });
            const { result } = response.data;
            // 预计算授权状态以提高性能
            const rows = result.rows || [];
            rows.forEach((item) => {
                // 预计算授权状态
                item._authStatus = this.getAuthStatus(item);
                item._authStatusText = this.getAuthStatusText(item);
                item._authStatusColor = this.getAuthStatusColor(item);
                // 初始化菜单状态
                item._hospitalMenuOpen = false;
                item._authMenuOpen = false;
            });
            this.list = rows;
            this.total = result.count || 0;
        }
        catch (error) {
            console.error('获取售后管理数据失败:', error);
            this.$refs.toast.error('获取数据失败');
        }
        finally {
            this.loading = false;
        }
    }
    // 编辑项目
    editItem(item) {
        this.formData = JSON.parse(JSON.stringify(item));
        // 根据医院名称匹配医院对象
        if (item.hospitalName) {
            this.formData.hospital = this.listHospital.find(h => h.name === item.hospitalName) || null;
        }
        this.dialog.title = '编辑设备信息';
        this.dialog.visible = true;
        this.editFormPanels = [0, 1, 2, 3, 4, 5]; // 展开所有面板
    }
    // 查看详情
    viewDetail(item) {
        this.formData = JSON.parse(JSON.stringify(item));
        // 根据医院名称匹配医院对象
        if (item.hospitalName) {
            this.formData.hospital = this.listHospital.find(h => h.name === item.hospitalName) || null;
        }
        this.dialog.title = '查看设备详情';
        this.dialog.visible = true;
        this.editFormPanels = [0, 1, 2, 3, 4, 5]; // 展开所有面板
    }
    // 保存项目
    async saveItem() {
        if (!this.$refs.form.validate()) {
            return;
        }
        this.saving = true;
        try {
            const data = { ...this.formData };
            // 处理医院对象
            if (data.hospital && typeof data.hospital === 'object') {
                data.hospitalId = data.hospital.id;
                data.hospitalName = data.hospital.name;
                delete data.hospital;
            }
            await this.axios.put(`/api/device/after-sales/${data.id}`, data);
            this.$refs.toast.success('保存成功');
            this.closeDialog();
            this.getList();
        }
        catch (error) {
            console.error('保存失败:', error);
            this.$refs.toast.error('保存失败');
        }
        finally {
            this.saving = false;
        }
    }
    // 关闭对话框
    closeDialog() {
        this.dialog.visible = false;
        this.formData = {};
        this.selectedItem = {};
        this.showMalfunctionHistory = false;
        this.malfunctionHistory = [];
        this.malfunctionCurrentPage = 1;
        this.$refs.form?.resetValidation();
    }
    // 切换故障历史显示
    async toggleMalfunctionHistory() {
        console.log('toggleMalfunctionHistory', this.showMalfunctionHistory);
        this.showMalfunctionHistory = !this.showMalfunctionHistory;
        if (this.showMalfunctionHistory && this.malfunctionHistory.length === 0) {
            // console.log('loadMalfunctionHistory', this.selectedItem, this.formData)
            await this.loadMalfunctionHistory();
        }
    }
    // 加载故障历史
    async loadMalfunctionHistory() {
        if (!this.formData.id) {
            return;
        }
        this.loadingMalfunctions = true;
        try {
            const response = await this.axios.get('/api/malfunctions', {
                params: {
                    deviceId: this.formData.id,
                    page: 1,
                    limit: 50
                }
            });
            if (response.data && response.data.result) {
                this.malfunctionHistory = response.data.result || [];
            }
            else if (response.data && response.data.error) {
                this.$message.error('加载故障历史失败：' + response.data.error);
            }
            else {
                this.malfunctionHistory = [];
            }
        }
        catch (error) {
            console.error('加载故障历史失败:', error);
            this.$message.error('加载故障历史失败');
        }
        finally {
            this.loadingMalfunctions = false;
        }
    }
    // 导出数据
    async exportData() {
        try {
            const params = { ...this.searchOptions, export: true };
            const response = await this.axios.get('/api/device/after-sales/export', {
                params,
                responseType: 'blob'
            });
            // 创建下载链接
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `售后管理数据_${new Date().toISOString().slice(0, 10)}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
            this.exportForm.menuVisible = false;
            this.$refs.toast.success('导出成功');
        }
        catch (error) {
            console.error('导出失败:', error);
            this.$refs.toast.error('导出失败');
        }
    }
    // 获取成功率颜色
    getSuccessRateColor(rate) {
        if (rate >= 95)
            return 'success';
        if (rate >= 90)
            return 'warning';
        return 'error';
    }
    // 获取成功率文字颜色
    getSuccessRateTextColor(rate) {
        if (rate >= 95)
            return '#ffffff';
        if (rate >= 90)
            return '#000000';
        return '#ffffff';
    }
    // 格式化HIS信息
    formatHisInfo(hisInfo) {
        if (!hisInfo)
            return '-';
        try {
            if (typeof hisInfo === 'string') {
                const parsed = JSON.parse(hisInfo);
                return JSON.stringify(parsed, null, 2);
            }
            else {
                return JSON.stringify(hisInfo, null, 2);
            }
        }
        catch (error) {
            return hisInfo;
        }
    }
    // 格式化小数（最多保留2位）
    formatDecimal(value) {
        if (value === null || value === undefined || value === '')
            return '0';
        const num = parseFloat(value);
        if (isNaN(num))
            return '0';
        return num.toFixed(2);
    }
    // 格式化日期时间为 YY-MM-dd hh:mm:ss
    formatDateTime(dateTime) {
        if (!dateTime)
            return '-';
        try {
            const date = new Date(dateTime);
            if (isNaN(date.getTime()))
                return '-';
            const year = date.getFullYear().toString().slice(-2);
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
        catch (error) {
            return '-';
        }
    }
    // 格式化无故障时长
    formatFaultFreeTime(time) {
        if (!time && time !== 0)
            return '-';
        const minutes = parseInt(time);
        if (isNaN(minutes))
            return '-';
        if (minutes < 60) {
            return `${minutes}分`;
        }
        else if (minutes < 1440) { // 小于24小时
            const hours = Math.floor(minutes / 60);
            return `${hours}h`;
        }
        else if (minutes < 43200) { // 小于30天
            const days = Math.floor(minutes / 1440);
            return `${days}天`;
        }
        else { // 大于等于30天
            const months = Math.floor(minutes / 43200);
            return `${months}月`;
        }
    }
    // 显示无故障时长详情
    showFaultFreeTimeDetail(item) {
        if (!item.faultFreeTime && item.faultFreeTime !== 0)
            return;
        const minutes = parseInt(item.faultFreeTime);
        console.log('minutes:', minutes);
        if (isNaN(minutes))
            return;
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor((minutes % 1440) / 60);
        const mins = minutes % 60;
        let detailText = '';
        if (days > 0)
            detailText += `${days}天`;
        if (hours > 0)
            detailText += `${hours}小时`;
        if (mins > 0)
            detailText += `${mins}分`;
        if (!detailText)
            detailText = '0分';
        this.$refs.toast.info(`无故障时长: ${detailText}`);
    }
    // 获取设备模式文本
    getDeviceModeText(mode) {
        const modeItem = this.deviceModeList.find((item) => item.value === mode);
        return modeItem ? modeItem.text : '-';
    }
    // 获取设备状态文本
    getDeviceStatusText(status) {
        const statusItem = this.statusList.find((item) => item.value === status);
        return statusItem ? statusItem.text : '-';
    }
    // 中间省略文本
    truncateMiddle(hospitalName, department, maxLength) {
        const fullText = hospitalName + department;
        if (fullText.length <= maxLength) {
            return fullText;
        }
        const ellipsis = '...';
        const availableLength = maxLength - ellipsis.length;
        const startLength = Math.ceil(availableLength / 2);
        const endLength = Math.floor(availableLength / 2);
        return fullText.substring(0, startLength) + ellipsis + fullText.substring(fullText.length - endLength);
    }
    // 获取授权状态
    getAuthStatus(item) {
        if (!item.authorizer) {
            return 'none';
        }
        if (!item.expireTime) {
            return 'valid';
        }
        const now = new Date();
        const expireDate = new Date(item.expireTime);
        const diffDays = Math.ceil((expireDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        if (diffDays < 0) {
            return 'expired';
        }
        else if (diffDays <= 30) {
            return 'expiring';
        }
        else {
            return 'valid';
        }
    }
    // 获取授权状态文本
    getAuthStatusText(item) {
        const status = this.getAuthStatus(item);
        switch (status) {
            case 'none':
                return '-';
            case 'expired':
                return '已过期';
            case 'expiring':
                return '即将到期';
            case 'valid':
            default:
                return item.authorizer || '-';
        }
    }
    // 获取授权状态颜色
    getAuthStatusColor(item) {
        const status = this.getAuthStatus(item);
        switch (status) {
            case 'none':
                return '#999999';
            case 'expired':
                return '#f44336';
            case 'expiring':
                return '#ff9800';
            case 'valid':
            default:
                return '#333333';
        }
    }
    // 格式化授权有效期
    formatAuthDuration(registerTime, expireTime) {
        if (!registerTime || !expireTime)
            return '-';
        try {
            const start = new Date(registerTime);
            const end = new Date(expireTime);
            const diffMs = end.getTime() - start.getTime();
            const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
            if (diffDays < 30) {
                return `${diffDays}天`;
            }
            else if (diffDays < 365) {
                const months = Math.floor(diffDays / 30);
                return `${months}个月`;
            }
            else {
                const years = Math.floor(diffDays / 365);
                const remainingDays = diffDays % 365;
                const remainingMonths = Math.floor(remainingDays / 30);
                if (remainingMonths > 0) {
                    return `${years}年${remainingMonths}个月`;
                }
                else {
                    return `${years}年`;
                }
            }
        }
        catch (error) {
            return '-';
        }
    }
};
__decorate([
    Watch('options', { deep: true })
], AfterSales.prototype, "onOptionsChanged", null);
__decorate([
    Watch('searchOptions', { deep: true })
], AfterSales.prototype, "onSearchOptionsChanged", null);
AfterSales = __decorate([
    Component({
        name: 'AfterSales',
        computed: {
            ...mapGetters(['deviceTypeList'])
        },
        methods: {
            ...mapActions(['fetchDeviceModeCatalog'])
        }
    })
], AfterSales);
export default AfterSales;
